/**
 * possible statuses
 *
 * https://bitbucket.hotterpads.com/projects/RP/repos/trulia/browse/rent-payment/src/main/java/com/hotpads/rentpayment/model/managetenants/PaymentCardStatus.java
 *
 * possible payment descriptions
 *
 * https://bitbucket.hotterpads.com/projects/RP/repos/trulia/browse/rent-payment/src/main/java/com/hotpads/rentpayment/model/managetenants/PaymentCardText.java
 *
 * possible CTA
 *
 * https://bitbucket.hotterpads.com/projects/RP/repos/trulia/browse/rent-payment/src/main/java/com/hotpads/rentpayment/model/managetenants/CallToActionText.java
 */
const PAYMENT_TYPE = {
    FAST_PAYOUT: 'fast payout',
    ONE_TIME_PAYMENT: 'one time payment',
    RECURRING_PAYMENT: 'recurring payment',
};

const PAYMENT_STATUS_TEXT = {
    FAILED: 'failed',
    PAID: 'paid',
    PAID_OFFLINE: 'paid offline',
    PAST_DUE: 'past due',
    PROCESSING: 'processing',
    REQUESTED: 'requested',
    RETURNED: 'returned',
    SENT: 'sent',
};

const PAYMENT_STATUS_TYPE = {
    CAUTION: 'caution',
    INFO: 'info',
    IN_PROGRESS: 'in_progress',
    NEUTRAL: 'neutral',
    SUCCESS: 'success',
    WARN: 'warn',
};

const PAYMENT_DESCRIPTION_TO_TYPE = {
    'monthly payment from': PAYMENT_TYPE.RECURRING_PAYMENT,
    'one-time payment from': PAYMENT_TYPE.ONE_TIME_PAYMENT,
};

export {
    PAYMENT_DESCRIPTION_TO_TYPE,
    PAYMENT_STATUS_TEXT,
    PAYMENT_STATUS_TYPE,
    PAYMENT_TYPE,
};
